"use strict";
exports.isTomorrow = isTomorrow;
var _index = require("./addDays.js");
var _index2 = require("./constructNow.js");
var _index3 = require("./isSameDay.js");
function isTomorrow(date) {
  return (0, _index3.isSameDay)(
    date,
    (0, _index.addDays)((0, _index2.constructNow)(date), 1)
  );
}
